import React from 'react';
import ReviewCard from './ReviewCard';
import LocationPreviewCard from './LocationPreviewCard';

export default function MapReviewCard({
  latitude,
  longitude,
  referenceLabel = '',
  referenceSummary = '',
  className = '',
}) {
  return (
    <div className={`space-y-3 ${className}`}>
      <ReviewCard
        title="Review Lokasi Instalasi"
        rows={[
          { label: 'Latitude', value: latitude ? String(latitude) : '-' },
          { label: 'Longitude', value: longitude ? String(longitude) : '-' },
          { label: 'Referensi Infra', value: referenceLabel || '-' },
          { label: 'Ringkasan', value: referenceSummary || '-' },
        ]}
      />
      <LocationPreviewCard
        latitude={latitude}
        longitude={longitude}
        title="Peta Konfirmasi Lokasi"
        emptyText="Lokasi belum dipilih. Anda tetap bisa simpan, namun validasi lapangan akan lebih sulit."
        compact={false}
      />
    </div>
  );
}

